import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TLDRInfiniteScroll from "../_components/common/TLDRInfiniteScroll";
import { StyledCenterAlignedRow } from "../_components/styled/ai/styledAi";
import { batch, connect } from "react-redux";
import { resetDocument } from "../_actions/aiDocumentActions";
import AIFavoriteDocument from "./AIFavoriteDocument";
import AIDocument from "./AIDocument";
import { FaPlusCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Icon } from "@chakra-ui/react";

function AiLastRuns(props) {
  const { t } = useTranslation(["ai"]);
  const [results, setResults] = useState(props.results);

  useEffect(() => {
    setResults(props.results);
  }, [props.results]);
  function loadMoreData() {}

  function handleNewDocumentOnClick() {
    batch(() => {
      props.resetDocument();
      props.onCreateNewDocument();
    });
  }

  const blankView = () => {
    return (
      <StyledCenterAlignedRow
        key={"blk"}
        className={""}
        onClick={(e) => handleNewDocumentOnClick()}
      >
        <Icon as={FaPlusCircle} mb={1} mr={2} /> {t("new_doc")}
      </StyledCenterAlignedRow>
    );
  };
  const allDocuments = results.map((result) => {
    return result.prompt === undefined ? (
      <AIFavoriteDocument
        key={`fav_${result.id}`}
        result={result}
        enableCardSelection={false}
      />
    ) : (
      <AIDocument
        key={`doc_${result.id}`}
        result={result}
        enableCardSelection={!props.renderlocation}
        showExtraOptions={props.showExtraOptions}
      />
    );
  });

  const childElements =
    allDocuments.length > 0 ? [blankView()].concat(allDocuments) : allDocuments;

  return (
    <TLDRInfiniteScroll
      className={
        props.renderlocation
          ? "ai-results-editor-infinite-scroll"
          : "ai-results-infinite-scroll"
      }
      childrens={childElements}
      hasMore={false}
      loadMoreData={loadMoreData}
      loaded={false} // Change its value whenever data get loaded.
    />
  );
}

AiLastRuns.propTypes = {
  results: PropTypes.array.isRequired,
  auth: PropTypes.object.isRequired,
  onCreateNewDocument: PropTypes.func.isRequired,
};

AiLastRuns.defaultProps = {
  showExtraOptions: false,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => {
  return {
    resetDocument: () => dispatch(resetDocument()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AiLastRuns);
